export default __webpack_public_path__ + "static/media/Swisslog.1080d806.png";